import { tns } from "tiny-slider/src/tiny-slider";
import { waitLoad } from "@blax-modules/base-front-end/resources/js/utilities/load";
import  {TemplateConstant} from "../../../../../../resources/js/templateConstant";

const DEFAULT_PARAMS = {
    container: '',
    primaryColor: '1B326C',
    secondaryColor: 'B91522',
    alternateSecondaryColor: 'FF0000',
    blackColor: '000000',
    whiteColor: 'FFFFFF',
    sliderConfig: {}
}

export class FullscreenSlider {
    constructor(aparams) {
        this.params = Object.assign({}, DEFAULT_PARAMS, aparams);
        waitLoad().then(() => this.init());
        this.navBtnColor = {
            normalColor:DEFAULT_PARAMS.whiteColor
        }
        this.slider = null;
    }


    init() {
        const templateValue = new TemplateConstant();
        const SLIDER_CONFIG = {
            container: this.params.container,
            items: 1,
            controls: false,
            slideBy: "page",
            mouseDrag: false,
            autoplay: this.params.autoplay,
            autoplayButtonOutput: false,
            swipeAngle: 30,
            speed: 500,
            autoplayTimeout: this.params.autoplayTimeout,
            preventScrollOnTouch: 'auto',
            navPosition: 'bottom',
            mode: "gallery",

        }
        const parentElem = document.querySelector('.home-banner');
        if (parentElem.getAttribute('data-slider-nav-btn'))
            this.navBtnColor.normalColor = parentElem.getAttribute('data-slider-nav-btn');

        this.setBtnColor();

        let sliderEl = document.querySelector(this.params.container)
        if (!sliderEl) {
            return
        }

        let slider = tns(Object.assign({},SLIDER_CONFIG,this.params.sliderConfig));
        this.slider = slider;

        this.initVideo(sliderEl);
        this.onIndexChanged(slider);

        let that2 = this;
        slider.events.on('indexChanged', function(a){
            console.log(that2.slider.getInfo());

            that.onIndexChanged;
            that2.flip(a.index);

        });

        this.flip(0);
        this.setNavColor();
        this.setTextAlign();
        this.setNavPosition();
        var that = this;
        var rellax = new Rellax('.home-slider', {
            speed: 4,
            callback: function(positions) {
                // callback every position change
                that.setNavPosition();
            }
        });

        const  headerHero = document.querySelector('.page-item--fixed');
        const mainHeader = document.querySelector('.single-banner__block__video');
        if(headerHero && mainHeader) {
            const headerHeroHeight = mainHeader.clientHeight;
            headerHero.style.height = headerHeroHeight + 'px';
        }

        window.addEventListener('resize', () => {
            this.setNavPosition();
        });

        //Check when GDPR for changes
        let gdpr = document.querySelector('.gdpr-message');
        if(gdpr != null){
            let that = this;

            document.querySelector('.gdpr-close').addEventListener('click', ()=> {
                setTimeout(() => {
                    that.setNavPosition(false);
                },250);
            });
        }
    }

    flip(index){
        let loop;
        let slider = this.slider;
        let slideCount = slider.getInfo().slideCount;

        let currentSlide = $(".home-slider__slide").eq(index);

        //Has many pictures
        if(currentSlide.find('.home-banner__picture').length > 1) {

            //Pause current slider

            if(slideCount > 1){
                slider.pause();
            }
            let count = 1;

            //Loop through all inner pictures of current slide
            loop = setInterval(function () {



                //Has more, then continue
                if(currentSlide.find('.home-banner__picture').length > count){

                    //Hide all
                    currentSlide.find('.home-banner__picture').each(function(){
                        $(this).removeClass('fade');
                    });
                    currentSlide.find('.home-banner__picture').eq(count).addClass('fade');
                    count++;

                    //It is the last inner picture
                }else{

                    if(slideCount > 1){
                        //Leave loop
                        clearInterval(loop);
                        //If available trigger next slide.
                        slider.goTo('next');

                        slider.play();
                    }else{
                        count = 1;
                    }

                    //Hide all
                    currentSlide.find('.home-banner__picture').each(function(){
                        $(this).removeClass('fade');
                    });
                    currentSlide.find('.home-banner__picture').eq(0).addClass('fade');
                }
            }, $('.home-banner').attr('data-slider-transition'));
        }
    }


    onResize() {
        const  headerHero = document.querySelector('.page-item--fixed');
        const mainHeader = document.querySelector('.single-banner__block__video');
        if(headerHero && mainHeader) {
            const headerHeroHeight = mainHeader.clientHeight;
            headerHero.style.height = headerHeroHeight + 'px';
        }
    }

    setBtnColor = () => {
        let slides = document.querySelectorAll('.tns-item');
        if(slides.length === 0)
            slides = document.querySelectorAll('.home-banner__content')

        for(let x = 0; x < slides.length; x++) {
            let btn = slides[x].querySelector('.new-slider-btn');
            if(btn){
                let curColors = [btn.style.backgroundColor, btn.style.color,btn.style.borderColor];

                const span = btn.querySelector('span');
                if(span) {
                    span.style.backgroundColor = btn.getAttribute('data-hover-bg-color');
                }

                btn.addEventListener('mouseover', function() {
                    btn.style.borderColor = this.getAttribute('data-hover-border-color');
                    btn.style.color = this.getAttribute('data-hover-text-color');
                });
                btn.addEventListener('mouseout', function() {
                    btn.style.backgroundColor = curColors[0];
                    btn.style.borderColor = curColors[2];
                    btn.style.color = curColors[1];
                })
            }
        }
    }
    setNavColor = () => {
        let slides = document.querySelectorAll('.tns-item');
        let tnsNav = document.querySelectorAll('.tns-nav button');
        for(let x = 0; x <= slides.length; x++) {
            if(slides[x]){
                if (tnsNav[x]) {
                    tnsNav[x].style.backgroundColor = '#' + this.navBtnColor.normalColor;
                }
            }
        }
    }

    setNavPosition = (gdprActive = true) => {
        if(window.innerHeight > window.innerWidth) {

            let activeItem = document.querySelector('.tns-item.tns-slide-active').querySelectorAll('.home-banner__content.container-v2');
            activeItem = activeItem[0].lastElementChild;


            if (activeItem != null) {
                const navPadding = 30;
                let lastElement = activeItem.getBoundingClientRect();
                let gdpr;

                if (gdprActive && document.querySelector('.gdpr-message') != null && document.querySelector('.gdpr-message').classList.contains('visible')) {
                    gdpr = document.querySelector('.gdpr-message.visible');
                    gdpr = gdpr.getBoundingClientRect();
                    gdpr = gdpr.height;
                } else {
                    gdpr = 0;
                }

                let offset = lastElement.height + lastElement.y + navPadding - gdpr;


                let nav = document.getElementsByClassName('tns-nav')[0];
                nav.style.top = offset + 'px';
            }
        }else{
            let nav = document.getElementsByClassName('tns-nav')[0];
            nav.style.top = '';
        }
    }

    setTextAlign = () => {
        let slides = document.querySelectorAll('.tns-item');
        for(let x = 0; x <= slides.length; x++) {
            if(slides[x] && slides[x].getAttribute('data-text-align')){
                slides[x].classList.add('text' +  slides[x].getAttribute('data-text-align'));
            }
        }
    }

    onIndexChanged = () => {

        let slide = document.querySelector(".tns-slide-active")
        let colorSetted = slide.getAttribute("data-color")
        let scrollBlock = document.querySelector(".scroll-block")
        if(scrollBlock) {
            scrollBlock.classList.remove('scroll-block--primary');
            scrollBlock.classList.remove('scroll-block--secondary');
            scrollBlock.classList.remove('scroll-block--black');
            scrollBlock.classList.remove('scroll-block--white');

            if (colorSetted === this.params.primaryColor) {
                scrollBlock.classList.add('scroll-block--primary')
            } else if (colorSetted === this.params.secondaryColor) {
                scrollBlock.classList.add('scroll-block--secondary')
            } else if (colorSetted === this.params.alternateSecondaryColor) {
                scrollBlock.classList.add('scroll-block--secondary')
            } else if (colorSetted === this.params.blackColor) {
                scrollBlock.classList.add('scroll-block--black')
            } else if (colorSetted === this.params.whiteColor) {
                scrollBlock.classList.add('scroll-block--white')
            }
        }

        let btnSlideEl = slide.querySelector('.btn--slide');
        if (!btnSlideEl)
            return;

        btnSlideEl.addEventListener('mouseenter', () => {
            btnSlideEl.getElementsByTagName('span')[0].style.display = ''
            btnSlideEl.addEventListener('mouseleave', (e) => {
                e.preventDefault();
                btnSlideEl.classList.add('slideOut')
                setTimeout(() => btnSlideEl.classList.remove('slideOut'), 250)
                setTimeout(() => btnSlideEl.getElementsByTagName('span')[0].style.display = 'none', 250)
                setTimeout(() => btnSlideEl.getElementsByTagName('span')[0].style.display = '', 500)
            })
        })
    }
    initVideo = (sliderEl) => {
        let newHeight, wrapper = sliderEl.closest('.home-banner'), videoEls = sliderEl.querySelectorAll('video');
        const resizeHandler = function () {
            const resize = function (vidEl) {
                let hasParallax = matchMedia('screen and (min-width:1024px)').matches, rect = vidEl.getBoundingClientRect(),
                    videoWidth = rect.width,
                    videoHeight = rect.height,
                    viewportHeight = window.innerHeight,
                    wrapperWidth = wrapper.getBoundingClientRect().width,
                    wrapperHeight;

                wrapperHeight = viewportHeight * (hasParallax ? 1.2 : 1);

                if (videoWidth / videoHeight < wrapperWidth / wrapperHeight) {
                    vidEl.style.width = wrapperWidth + 'px';
                    vidEl.style.height = 'auto';
                    vidEl.classList.remove('vertical')
                }
                else {
                    vidEl.style.width = 'auto';
                    if (hasParallax)
                        vidEl.style.height = wrapperHeight + 'px';
                    else
                        vidEl.style.height = '100vh';
                    vidEl.classList.add('vertical')
                }
            }

            const onLoad = function (vidEl) {
                let rect = vidEl.getBoundingClientRect();

                if (rect.width && rect.height) {
                    resize.call(null, vidEl)
                }
                vidEl.parentElement.classList.remove('preloading-like')
            }

            const play = function (vidEl) {
                var sourceEl = vidEl.querySelector('source');
                vidEl.classList.remove('hidden');

                if (!sourceEl.getAttribute('src')) {
                    var time = function () {
                        if (vidEl.readyState >= 3) {
                            onLoad.call(null, vidEl);
                        }
                        else {
                            setTimeout(time, 400)
                        }
                    };
                    setTimeout(time, 400)
                    vidEl.parentElement.classList.remove('preloading-like')
                    sourceEl.setAttribute('src', sourceEl.getAttribute('data-src'));
                    vidEl.load();
                }
                else {
                    var w = vidEl.videoWidth, h = vidEl.videoHeight;
                    if (w && h) {
                        resize.call(null, vidEl)
                    }
                }
            }

            videoEls.forEach((vid) => {
                let rect = vid.getBoundingClientRect();
            })

            if (matchMedia('screen and (min-width:1024px)').matches) {
                videoEls.forEach((vid) => {
                    if (vid.matches('.slider-desktop')) {
                        play(vid)
                    }
                    else {
                        vid.classList.add('hidden')
                    }
                })
            }
            else {
                videoEls.forEach((vid) => {
                    if (vid.matches('.slider-mobile')) {
                        play(vid)
                    }
                    else {
                        vid.classList.add('hidden')
                    }
                })
            }
        }
        window.addEventListener('resize', resizeHandler)
        resizeHandler();
    }

    getTranslateX = (myElement) => {
        const elStyle = myElement.getAttribute('style')
        if (elStyle && elStyle.length > 0) {
            let tmpStr = myElement.getAttribute('style').split('translate3d(');
            let subStr1 = tmpStr.splice(tmpStr.indexOf(tmpStr))
            let transStr = subStr1[0].split('%,')
            return transStr[0];
        }
    }
    hideHomeSliderOnScroll = (sliderEl) => {
        window.addEventListener('scroll', (e) => {
            const sliderParent = sliderEl.parentElement.parentElement;
            if (window.scrollY > window.innerHeight) {
                if (!sliderParent.classList.contains('hide')) {
                    sliderParent.classList.add('hide');
                }
            } else {
                if (sliderParent.classList.contains('hide')) {
                    sliderParent.classList.remove('hide');
                }
            }
        });
    }
}

export class slider {
    constructor(containerClass) {
        this.containerClass = containerClass;
        this.sliderHome();
    }
}
